<template>
  <!-- comment-item -->
  <div class="flex-box child-comments" v-if="!options.deleteComment">
    <span class="info-userimg">
      <router-link :to="{ name: 'User', params: { userId: propChildComment.userId}}">
        <img v-if="getUserInfoById(getChildComment.userId).userIcon" :src="getUserInfoById(getChildComment.userId).userIcon" :alt="getUserInfoById(getChildComment.userId).userName || ''" class="img-circle">
        <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
      </router-link>
    </span>
    <div class="comment">
      <div class="info-userelement">
        <span class="info-username">{{ getUserInfoById(getChildComment.userId).userName || '' }}</span>
        <span class="info-time">
          {{getChildComment.createdAt | preparedTime}}
        </span>
      </div>
      <div v-if="getContentText.isDelete">{{getContentText}}</div>
      <div v-else-if="getChildComment.isStamp" class="show-stamp">
        <img :src="getStampImg(getChildComment.isStamp)" :alt="getChildComment.isStamp">
      </div>
      <!-- {{obj}} -->
      <read-more :targetId="getChildComment.id" :text="getContentText" :isGrayOut="!!propChildComment.isDelete" :addMore="true" :showMore="propShowMore" :contentHeight="propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight" :replyTo="getReplyTo(getChildComment)" />
      <span v-if="getChildComment.uploadedFile" class="image-add">
        <b-row>
          <b-col>
            <div class="uploaded-images" v-viewer="{
              button: true,
              navbar: false,
              title: false,
              toolbar: false,
              tooltip: false,
              movable: true,
              zoomable: true,
              rotatable: true,
              scalable: false,
              transition: true,
              fullscreen: true,
              keyboard: false }" @click.stop>
              <img :src="getChildComment.uploadedFile">
            </div>
          </b-col>
        </b-row>
      </span>
      <div class="child-tools">
        <span class="info-menu">
          <a @click="onClickReply" class="info-comment-detail collapse-reply">
            <i class="fa fa-mail-reply fa-rotate-180"></i>
          </a>
        </span>
        <span v-if="checkCommentIsDelete(getChildComment)" class="info-right">
          <comment-drop-down @comment-delete="commentDelete(getChildComment)"/>
        </span>
      </div>
    </div>
  </div>
  <!-- /comment-item -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CommentDropDown from '@/components/Comment/CommentDropDown'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import moment from 'moment'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import { stampsurl } from '@/main'
import Vue from 'vue'
Vue.use(Viewer)

export default {
  name: 'ChildCommentItem',
  props: {
    propChildComment: {
      type: Object
    }
  },
  components: {
    CommentDropDown,
    ReadMore
  },
  data () {
    return {
      options: {
        showCounter: false,
        widthRatio: 0.5,
        heightRatio: 0.5,
        nav: false,
        enableKeyboard: false,
        close: false,
        deleteComment: false
      },
      propShowMore: false,
      propContentHeight: 0
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ]),
    // ...mapGetters('comments/', [
    //   'getChildCommentsByParentId'
    // ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    // getComment () {
    //   retur
    // },
    getChildComment () {
      return this.propChildComment
    },
    getContentText () {
      if (!this.propChildComment.isDelete) {
        return this.propChildComment.contentText
      } else {
        this.options.deleteComment = true
        return this.$t('deletedComentStr')
      }
    }
    // getChildComments () {
    //   return this.getChildCommentsByParentId(this.Comments.id, this.Comments.target)
    // }
  },
  updated: function () {
    console.log(this.getChildComment.userId)
  },
  methods: {
    ...mapActions('comments/', {
      removeCommnet: 'REMOVE_COMMENT'
    }),
    getReplyTo: function (comment) {
      console.log('getReplyTo:', comment)
      let replyTo = ''
      if (comment.parentId) {
        console.log('getReplyTo:parentId', comment.parentId)
        let parentUserName = comment.parentUserName || ''
        if (!parentUserName) {
          let parentUserInfo = this.getUserInfoById(comment.parentId)
          if (parentUserInfo.userName) {
            parentUserName = '@' + parentUserInfo.userName
          }
        }
        console.log('highlightReplyToContentText:parentUserName', parentUserName)
        replyTo = parentUserName
      }
      return replyTo
    },
    highlightReplyToContentText: function (comment) {
      console.log('highlightReplyToContentText:', comment)
      if (!(comment && comment.id)) { return '' }
      let contentText = comment.contentText || ''
      if (comment.parentId) {
        console.log('highlightReplyToContentText:parentId', comment.parentId)
        let parentUserName = comment.parentUserName || ''
        if (!parentUserName) {
          let parentUserInfo = this.getUserInfoById(comment.parentId)
          if (parentUserInfo.userName) {
            parentUserName = '@' + parentUserInfo.userName
          }
        }
        console.log('highlightReplyToContentText:parentUserName', parentUserName)
        let re = new RegExp('^' + parentUserName.trim())
        console.log('highlightReplyToContentText:RegExp', re)
        contentText = contentText.replace(re, '<span class="replyto">' + parentUserName + '</span>')
        console.log('highlightReplyToContentText:contentText', contentText)
      }
      return contentText
    },
    checkCommentIsDelete: function (comment) {
      if (comment.userId === this.getUserId && !comment.isDelete) {
        return true
      } else {
        return false
      }
    },
    onClickReply: function () {
      let parentItem
      // if (value === 'parent') {
      //   parentItem = {
      //     item: this.Comments,
      //     id: itemId
      //   }
      //   this.$emit('call-set-reply', parentItem)
      // // } else {
      console.log('setParentCommentId child:::', this.getChildComment)
      let item = this.getChildComment
      let id = this.getChildComment.id
      parentItem = {
        item: item,
        id: id
      }
      this.$emit('call-set-reply', parentItem)
      // }
    },
    commentDelete: function (comment) {
      // console.log('commentDelete', parentId)
      // console.log('commentId', this.Comments.id)
      let deleteInfo = {}
      // console.log(comment)
      // if (string === 'child') {
      deleteInfo = {
        parentId: comment.parentId,
        commentId: comment.id,
        targetId: comment.targetId,
        target: comment.target,
        userId: comment.userId,
        targetOwner: comment.targetOwner,
        remtext: this.$t('deletedComentStr')
      }
      // }
      //  else {
      //   // console.log(this.getChildCommentsByParentId(comment.id, comment.target))
      //   if (this.getChildCommentsByParentId(comment.id, comment.target).length > 0) {
      //     deleteInfo = {
      //       parentId: 'parent',
      //       commentId: comment.id,
      //       targetId: comment.targetId,
      //       target: comment.target,
      //       userId: comment.userId
      //     }
      //   } else {
      //     deleteInfo = {
      //       parentId: 'notParent',
      //       commentId: comment.id,
      //       targetId: comment.targetId,
      //       target: comment.target,
      //       userId: comment.userId
      //     }
      //   }
      // }
      if (comment.uploadedFile) {
        console.log('deleteInfo add deleteimage')
        deleteInfo.uploadedFile = comment.uploadedFile
      }
      this.removeCommnet(deleteInfo)
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      // console.log('in comment updateContentHeight::', value)
      this.propContentHeight = value
    },
    getStampImg (key) {
      var url = stampsurl.host + '/stamp/' + key
      return url
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    },
    momentDay: function (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    momentTime: function (date) {
      return moment(date).format('HH:mm:ss')
    }
  }
}
</script>
<style lang="scss" scoped>
.child-comments{
  padding: 10px 0 10px 20px;
  border-top: solid 1px #e7eaec;
}
.clicked{
  border-color: #F0E0E0;
  border-style: solid;
  border-width: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Comment/ChildCommentItemInManage.vue